export default __webpack_public_path__ + "static/Haier Indoor-bd0d822a6c5ec4198a875b9c807e747a.jpg";